// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import './pages/Home.css';
import { RiAccountCircleFill } from "react-icons/ri";
import LoginSignup from './pages/LoginSignup';
import Watchlist from "./pages/Watchlist"; 
import { Link } from "react-router-dom";
import { useState } from "react";
import { useUser } from './context/UserContext';
function App() {
   const { username } = useUser();


  const [showMsg, setShowMsg] = useState(false);
  
  const handleClick = () => {
    setShowMsg(true);

    // Hide the message after 3 seconds (3000ms)
    setTimeout(() => {
      setShowMsg(false);
    }, 2000);
  };
  return (
    
    <Router>
     <nav className="navbar">
    <div className="nav-container">
      <h2 className="logo" style={{fontFamily:"serif"}}>🎬 WatchHive</h2>
      <div className="nav-links">
        <Link to="/" >Home</Link>
        <Link to="/watchlist">Watchlist</Link>
        <Link to="/login">Login</Link>
         <button
        onClick={handleClick}
        style={{
          background: "transparent",
          border: "none",
          cursor: "pointer",
          padding: "6px 12px",
        }}
      >
        <RiAccountCircleFill
          style={{
            color: "white",
            height: "30px",
            width: "30px",
            verticalAlign: "middle",
          }}
        />
      </button>
       {showMsg && (
        <span
          style={{
            position: "absolute",
            top: "60px",
            right: "10px",
            background: "white",
            color: "black",
            padding: "8px 12px",
            borderRadius: "6px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            fontSize: "14px",
          }}
        >
          {username ? `Hello, ${username}` : "Hello, Guest"}
        </span>
      )}
      </div>
    </div>
  </nav>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/watchlist" element={<Watchlist />} />
        <Route path="/login" element={<LoginSignup />} />
        {/* More routes coming soon: Watchlist, Watched */}
      </Routes>
    </Router>
  );
}

export default App;